import React from 'react';

interface BrandCategorySolidIconProps {
  className?: string;
}

function BrandCategorySolidIcon(props: BrandCategorySolidIconProps) {
  const { className = '' } = props;

  return (
    <svg
      className={className}
      viewBox="0 0 17 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8.6665 16C10.7882 16 12.8231 15.1571 14.3234 13.6569C15.8236 12.1566 16.6665 10.1217 16.6665 8C16.6665 5.87827 15.8236 3.84344 14.3234 2.34315C12.8231 0.842855 10.7882 0 8.6665 0C6.54477 0 4.50994 0.842855 3.00965 2.34315C1.50936 3.84344 0.666504 5.87827 0.666504 8C0.666504 10.1217 1.50936 12.1566 3.00965 13.6569C4.50994 15.1571 6.54477 16 8.6665 16ZM6.89775 9.76875C7.87275 10.7438 9.45713 10.7438 10.4321 9.76875C10.7259 9.475 11.2009 9.475 11.4915 9.76875C11.7821 10.0625 11.7853 10.5375 11.4915 10.8281C9.929 12.3906 7.39775 12.3906 5.83525 10.8281C4.27275 9.26562 4.27275 6.73438 5.83525 5.17188C7.39775 3.60938 9.929 3.60938 11.4915 5.17188C11.7853 5.46562 11.7853 5.94062 11.4915 6.23125C11.1978 6.52187 10.7228 6.525 10.4321 6.23125C9.45713 5.25625 7.87275 5.25625 6.89775 6.23125C5.92275 7.20625 5.92275 8.79062 6.89775 9.76562V9.76875Z" />
    </svg>
  );
}

export default BrandCategorySolidIcon;
